import { render, staticRenderFns } from "./FailPayoutPage.vue?vue&type=template&id=5f28df57&scoped=true&"
import script from "./FailPayoutPage.vue?vue&type=script&lang=js&"
export * from "./FailPayoutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f28df57",
  null
  
)

export default component.exports